import React from 'react';

import Button from '@uikit/Form/Button/Button';
import ColoredLabel from '@uikit/old/ColoredLabel/ColoredLabel';
import { TableConfigType } from '@uikit/old/ConfigurableTable/ConfigurableTable';
import { SVGIcon } from '@uikit/old/Icon/Icon';
import TimestampToDate from '@uikit/TimestampToDate/TimestampToDate';

import { statusLabelColor } from '../../utils';

export type WithdrawalsTableRenderProps = {
  onDownload: (id: number) => void;
  activeDownloadId: number | null;
};

export const withdrawalsTableConfig: TableConfigType = [
  { title: 'Transaction ID', dataKey: 'transactionId' },
  {
    title: 'Withdrawals on',
    dataKey: 'withdrawalOn',
    cellClassName: 'withdrawals-table__date-cell',
    RenderCell: ({ row }) => (
      <div>
        <TimestampToDate timestamp={row.withdrawalOn} />
        <div>By {row.withdrawalBy?.fullName}</div>
      </div>
    ),
  },
  {
    title: 'Payment method',
    dataKey: 'paymentMethodFormatted',
    RenderCell: ({ row }) => (
      <div>
        <div>{row.paymentMethodFormatted}</div>
        <div>{row.withdrawalBy?.email}</div>
      </div>
    ),
  },
  {
    title: 'Status',
    dataKey: 'statusFormatted',
    RenderCell: ({ row }) => (
      <ColoredLabel color={statusLabelColor(row.statusFormatted)}>
        {row.statusFormatted}
      </ColoredLabel>
    ),
  },
  {
    title: 'Amount',
    dataKey: 'amountFormatted',
    RenderCell: ({ row }) => (
      <div>
        <div>{row.amountFormatted}</div>
        {row.feeFormatted && (
          <div className="withdrawals-table__fee-cell">Transfer fee {row.feeFormatted}</div>
        )}
      </div>
    ),
  },
  {
    title: 'Receipt',
    dataKey: 'receipt',
    RenderCell: ({ row, renderProps }) => (
      <Button
        className="withdrawals-table__receipt-btn"
        type="blue"
        size="xs"
        onClick={() => (renderProps as WithdrawalsTableRenderProps).onDownload(row.id)}
        isLoading={(renderProps as WithdrawalsTableRenderProps).activeDownloadId === row.id}
        disabled={(renderProps as WithdrawalsTableRenderProps).activeDownloadId !== null}
      >
        <SVGIcon icon="download" size={8} />
      </Button>
    ),
  },
];
